import React, { useState, useEffect } from 'react';
import { FaBrain, FaLightbulb, FaExclamationTriangle, FaInfoCircle, FaSpinner } from 'react-icons/fa';
import { get } from '../../helpers/apiHelper';
import useAuthStore from '../../store/authStore';

const InsightsCard = () => {
    const { user } = useAuthStore();
    const [analysis, setAnalysis] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user?.userId) {
            fetchAnalysis();
        }
    }, [user]);

    const fetchAnalysis = async () => {
        try {
            setLoading(true);
            const response = await get(`weekly-analysis/saved/${user.userId}`);
            if (response && response.insights) {
                setAnalysis(response);
            }
        } catch (err) {
            console.error('Error fetching analysis for insights:', err);
        } finally {
            setLoading(false);
        }
    };

    // Si no hay insights, mostrar un mensaje informativo
    if (!analysis || !analysis.insights) {
        return (
            <div className="insights-placeholder">
                <div className="text-center py-8">
                    <FaInfoCircle className="text-3xl mx-auto mb-3 text-gray-400" />
                    <p className="text-gray-600 font-medium">Próximamente</p>
                    <p className="text-gray-500 text-sm">Análisis IA</p>
                </div>
            </div>
        );
    }

    const { insights } = analysis;

    return (
        <div className="space-y-3">
            {/* Oportunidades */}
            {insights.opportunities && insights.opportunities.length > 0 && (
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-400 rounded-r-lg p-3 shadow-sm">
                    <div className="flex items-center mb-2">
                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                            <FaLightbulb className="text-green-600 text-sm" />
                        </div>
                        <h4 className="text-sm font-semibold text-green-800">Oportunidades</h4>
                    </div>
                    <ul className="space-y-1 ml-11">
                        {insights.opportunities.slice(0, 2).map((opp, index) => (
                            <li key={index} className="text-xs text-green-700 leading-relaxed">
                                {opp}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Áreas de Atención */}
            {insights.areasOfConcern && insights.areasOfConcern.length > 0 && (
                <div className="bg-gradient-to-r from-orange-50 to-amber-50 border-l-4 border-orange-400 rounded-r-lg p-3 shadow-sm">
                    <div className="flex items-center mb-2">
                        <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                            <FaExclamationTriangle className="text-orange-600 text-sm" />
                        </div>
                        <h4 className="text-sm font-semibold text-orange-800">Áreas de Atención</h4>
                    </div>
                    <ul className="space-y-1 ml-11">
                        {insights.areasOfConcern.slice(0, 2).map((concern, index) => (
                            <li key={index} className="text-xs text-orange-700 leading-relaxed">
                                {concern}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Amenazas */}
            {insights.threats && insights.threats.length > 0 && (
                <div className="bg-gradient-to-r from-red-50 to-pink-50 border-l-4 border-red-400 rounded-r-lg p-3 shadow-sm">
                    <div className="flex items-center mb-2">
                        <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-3">
                            <FaExclamationTriangle className="text-red-600 text-sm" />
                        </div>
                        <h4 className="text-sm font-semibold text-red-800">Amenazas</h4>
                    </div>
                    <ul className="space-y-1 ml-11">
                        {insights.threats.slice(0, 2).map((threat, index) => (
                            <li key={index} className="text-xs text-red-700 leading-relaxed">
                                {threat}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Top Performers */}
            {insights.topPerformers && insights.topPerformers.length > 0 && (
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-400 rounded-r-lg p-3 shadow-sm">
                    <div className="flex items-center mb-2">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                            <FaBrain className="text-blue-600 text-sm" />
                        </div>
                        <h4 className="text-sm font-semibold text-blue-800">Fortalezas</h4>
                    </div>
                    <ul className="space-y-1 ml-11">
                        {insights.topPerformers.slice(0, 2).map((performer, index) => (
                            <li key={index} className="text-xs text-blue-700 leading-relaxed">
                                {performer}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default InsightsCard; 